// extracted by mini-css-extract-plugin
export var card = "_v0-0";
export var details = "_v0-1";